import React from 'react';

const Placeholder = () => (
  <div className="placeholders">
    <div className="ph-wrapper">
      <div className="ph-headers">
        <div className="ph-item main-nav" />
      </div>
      <div className="ph-app">
        <div className="ph-main">
          <div className="ph-tabs">
            <div className="ph-item contextual-nav nomargin" />
            <div className="ph-item separator" />
          </div>
          <div className="ph-content">
            <div className="ph-main-col">
              <div className="ph-item carousel" />
              <div className="ph-item main-promo" />
              <div className="ph-item module">
                <div className="module-header" />
                <div className="module-subheader" />
                <div className="module-item">
                  <div className="module-square col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
                <div className="module-item">
                  <div className="module-square col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
                <div className="module-item">
                  <div className="module-square col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
              </div>
              <div className="ph-item module">
                <div className="module-header" />
                <div className="module-subheader" />
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
              </div>
              <div className="ph-item module">
                <div className="module-header" />
                <div className="module-subheader" />
                <div className="module-item">
                  <div className="module-double-square col-1" />
                  <div className="module-text col-5">
                    <div className="module-text-line doublespace col-10" />
                    <div className="module-text-line doublespace col-12" />
                  </div>
                  <div className="module-multiple-selection col-6" />
                </div>
                <div className="module-item">
                  <div className="module-double-square col-1" />
                  <div className="module-text col-5">
                    <div className="module-text-line doublespace col-10" />
                    <div className="module-text-line doublespace col-12" />
                  </div>
                  <div className="module-multiple-selection col-6" />
                </div>
                <div className="module-item">
                  <div className="module-double-square col-1" />
                  <div className="module-text col-5">
                    <div className="module-text-line doublespace col-10" />
                    <div className="module-text-line doublespace col-12" />
                  </div>
                  <div className="module-multiple-selection col-6" />
                </div>
                <div className="module-item">
                  <div className="module-double-square col-1" />
                  <div className="module-text col-5">
                    <div className="module-text-line doublespace col-10" />
                    <div className="module-text-line doublespace col-12" />
                  </div>
                  <div className="module-multiple-selection col-6" />
                </div>
                <div className="module-item">
                  <div className="module-double-square col-1" />
                  <div className="module-text col-5">
                    <div className="module-text-line doublespace col-10" />
                    <div className="module-text-line doublespace col-12" />
                  </div>
                  <div className="module-multiple-selection col-6" />
                </div>
              </div>
            </div>
            <div className="ph-right-col">
              <div className="ph-item main-promo" />
              <div className="ph-item module">
                <div className="module-header" />
                <div className="module-subheader" />
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                  </div>
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                  </div>
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                  </div>
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                  </div>
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                  </div>
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                  </div>
                </div>
              </div>
              <div className="ph-item module">
                <div className="module-header" />
                <div className="module-subheader" />
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
                <div className="module-item">
                  <div className="module-circle col-1" />
                  <div className="module-text col-8">
                    <div className="module-text-line col-12" />
                    <div className="module-text-line col-6" />
                  </div>
                  <div className="module-selection col-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ph-betslip">
          <div className="ph-item carousel nomargin" />
          <div className="ph-item carousel nomargin" />
          <div className="ph-item carousel" />
        </div>
      </div>
    </div>
  </div>
);

export default Placeholder;
